import { render, staticRenderFns } from "./StepUmDadosSolicitante.vue?vue&type=template&id=fa5889ac&scoped=true"
import script from "./StepUmDadosSolicitante.vue?vue&type=script&lang=js"
export * from "./StepUmDadosSolicitante.vue?vue&type=script&lang=js"
import style0 from "./StepUmDadosSolicitante.vue?vue&type=style&index=0&id=fa5889ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5889ac",
  null
  
)

export default component.exports